import { initializeApp } from "firebase/app"
import { getFirestore, onSnapshot, doc } from "firebase/firestore"
import { ENV } from "./env"

const config = {
  production: {
    apiKey: "AIzaSyAR-Uv6DKYpzMrBF_8GylhWWkT2tvX0XDk",
    authDomain: "m5azen.firebaseapp.com",
    projectId: "m5azen",
    databaseURL: "https://m5azen.firebaseio.com",
    storageBucket: "m5azen.firebasestorage.app",
    messagingSenderId: "466610576305",
    appId: "1:466610576305:web:37dfd1efd27db592517b90",
    measurementId: "G-FWCQSH6LJ2",
  },
  staging: {
    apiKey: "AIzaSyAR-Uv6DKYpzMrBF_8GylhWWkT2tvX0XDk",
    authDomain: "m5azen.firebaseapp.com",
    projectId: "m5azen",
    databaseURL: "https://m5azen.firebaseio.com",
    storageBucket: "m5azen.firebasestorage.app",
    messagingSenderId: "466610576305",
    appId: "1:466610576305:web:4909bf1a97403399517b90",
    measurementId: "G-BJFTES2D98",
  },
  development: {
    apiKey: "AIzaSyAR-Uv6DKYpzMrBF_8GylhWWkT2tvX0XDk",
    authDomain: "m5azen.firebaseapp.com",
    projectId: "m5azen",
    databaseURL: "https://m5azen.firebaseio.com",
    storageBucket: "m5azen.firebasestorage.app",
    messagingSenderId: "466610576305",
    appId: "1:466610576305:web:4909bf1a97403399517b90",
    measurementId: "G-BJFTES2D98",
  },
}

export const app = initializeApp(config[ENV.channel])
const firestore = getFirestore(app)

export { onSnapshot, doc, firestore }
